<template>
  <div class="text-center">
    <ButtonLink 
      text="Start Your Free Trial"
      url="/free-trial"
      color="black"
    />
  </div>
</template>

<script>
import ButtonLink from '../Common/ButtonLink.vue'

export default {
  name: 'ProgramCTA',
  components: {
    ButtonLink
  }
}
</script> 